import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { ACTION_COMMANDS_TYPE } from '../../../api/ActionCommandsInterface/constants';
import { EVENT_EMITTER_TYPE } from '../../../constants';
import Emitter from '../../../services/EmitterService';
import { useLazyGetDailyWheelDataQuery } from '../../../state/query/dailyWheel';

var useDailySpinContainer = function useDailySpinContainer(props) {
  var dismissModal = props.dismissModal;

  var _useLazyGetDailyWheel = useLazyGetDailyWheelDataQuery(),
      _useLazyGetDailyWheel2 = _slicedToArray(_useLazyGetDailyWheel, 1),
      getDailyWheel = _useLazyGetDailyWheel2[0];

  var skipDailyWheel = function skipDailyWheel() {
    dismissModal();
    Emitter.emit(EVENT_EMITTER_TYPE.ACTION_COMMANDS, {
      actionType: ACTION_COMMANDS_TYPE.CLEAR_ACTION_COMMAND
    });
  };

  var fetchDailyWheelData = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return getDailyWheel().unwrap();

          case 3:
            response = _context.sent;
            if (!response || response && !response[0]) skipDailyWheel();
            _context.next = 10;
            break;

          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](0);
            skipDailyWheel();

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 7]]);
  })), []);
  useEffect(function () {
    fetchDailyWheelData();
  }, [fetchDailyWheelData]);
  var dailyWheelAssets = useSelector(function (state) {
    return state.assetsPackage.assets.DAILY_WHEEL;
  });
  var bonusRes = useSelector(function (state) {
    return state.load.bonusRes;
  });
  return {
    dailyWheelAssets: dailyWheelAssets,
    bonusRes: bonusRes
  };
};

export default useDailySpinContainer;